import React from "react";
import copy from "../data/copy";

export default ({ languageId, progress }) => {
  const prog = Math.floor(progress * 100);
  return (
    <div id="loading-overlay" className="loading-overlay">
      <div className="loading-wrapper">
        <h3>{copy[languageId].loading}</h3>
        {progress === 1 ? (
          <div className="spinner">
            <div className="bounce1" />
            <div className="bounce2" />
            <div className="bounce3" />
            <div className="bounce4" />
          </div>
        ) : (
          <div className="Progress">
            <progress max="100" value={prog} className="Progress-main">
              <div className="Progress-bar" role="presentation">
                <span className="Progress-value" style={{ width: `${prog}%` }}>
                  {" "}
                </span>
              </div>
            </progress>
            <div className="Progress-label">
              <strong>{prog}%</strong>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./application/frontend/src/components/Loading.js